import { render, staticRenderFns } from "./FaveMix.vue?vue&type=template&id=0297ccdd&scoped=true&"
import script from "./FaveMix.vue?vue&type=script&lang=js&"
export * from "./FaveMix.vue?vue&type=script&lang=js&"
import style0 from "./FaveMix.vue?vue&type=style&index=0&id=0297ccdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0297ccdd",
  null
  
)

export default component.exports